import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const TableCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  gap: ${spacing.eighth};

  > :nth-child(2) {
    width: 100%;
  }
`;
